export const APP_ROUTES = {
  HOME: "/",

  SIGN_IN: "/sign-in",
  FORGET_PASSWORD: "/forget-password",
  RESET_PASSWORD: "/reset-password",

  PROFILE: "/profile",
  DASHBOARD: "/dashboard",

  STAFF: "/staff",
  STAFF_DETAIL: "/staff-detail/:staffId",
  STAFF_CREATE: "/staff-create",
  STAFF_EDIT: "/staff-edit/:staffId",
  TEAMS: "/staff/teams",

  TIMESHEET: "/timesheet",
  TIMESHEET_TIMEKEEPING: "/timesheet-timekeeping",

  SETTING: "/setting",
  HR_ASSISTANT: "/hr-assistant",
  DEVICES: "/devices",
  ATTENDANCE_EVIDENCE: "/attendance-evidence",
} as const;
